<template>
  <div class="footer">
    <div class="footer-mid">
      <div class="footerBg">
        <img src="../assets/login/footerbg.png">
        <i class="bgColor" style="background-color: #0065BA;"></i>
      </div>
      <div class="mid">
        <div class="footer-content">
          <!-- 左侧：友情链接 -->
          <div class="footer-section links-section">
            <h3 class="section-title">友情链接</h3>
            <div class="links-container d-flex d-flex-between d-flex-wrap">
              <a href="#" class="link-item">中华人民共和国教育部</a>
              <a href="#" class="link-item">中华人民共和国科学技术部</a>
              <a href="#" class="link-item">四川省人民政府</a>
              <a href="#" class="link-item">四川省科学技术厅</a>
              <a href="#" class="link-item">四川省教育厅</a>
              <a href="#" class="link-item">四川省高校网络理政平台</a>
            </div>
          </div>

          <!-- 中间：大学品牌和二维码 -->
          <div class="footer-section brand-section">
            <div class="brand-info">
              <img src="../assets/logo/logo_f.png" alt="西南科技大学" class="university-logo">
            </div>
            <div class="qr-codes">
              <div class="qr-code-item">
                <img src="../assets/login/ewm_1.png" alt="公众号" class="qr-code">
              </div>
              <div class="qr-code-item">
                <img src="../assets/login/ewm_2.png" alt="微博" class="qr-code">
              </div>
            </div>
          </div>

          <!-- 右侧：联系我们 -->
          <div class="footer-section contact-section">
            <h3 class="section-title">联系我们</h3>
            <div class="contact-info">
              <div class="contact-item">
                <img src="../assets/footIcon_1.png" alt="" class="contact-icon">
                <span class="contact-text">邮编: 621010</span>
              </div>
              <div class="contact-item">
                <img src="../assets/footIcon_2.png" alt="" class="contact-icon">
                <span class="contact-text">地址: 四川省绵阳市涪城区青龙大道中段59号</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <div class="footer-copyright">
        <div class="copyright">
          <img src="../assets/login/1681190825355.png" width="24px" height="26px" alt="">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42018502002305" style="margin-left: 4px;">{{ tenantInfo.footer }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"

export default {
 computed: {
    ...mapState(['tenantInfo'])
  },
}
</script>
<style lang="scss" scoped>
.footer {
  .footer-mid {
    position: relative;

    .footerBg {
      position: absolute;
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      i {
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        opacity: 0.9;
      }
    }

    .mid {
      box-sizing: border-box;
      padding: 50px 0 30px 0;
      position: relative;
      z-index: 3;
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;

      .footer-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0 20px;
        gap: 40px;
      }

      .footer-section {
        color: #fff;

        &.links-section {
          flex: 0 0 300px;
        }

        &.brand-section {
          flex: 0 0 400px;
        }

        &.contact-section {
          flex: 0 0 300px;
        }

        .section-title {
          font-size: 14px;
          font-weight: bold;
          color: #fff;
          margin-bottom: 20px;
          line-height: 1;
        }

        &.links-section {
          .links-container {
            width: 360px;
            .link-item {
                color: #fff;
                font-size: 12px;
                text-decoration: none;
                line-height: 1.8;
                transition: opacity 0.3s;
                width: 50%;
                line-height: 30px;
                &:hover {
                  opacity: 0.8;
                }
              }
          }
        }

        &.brand-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;

          .brand-info {
            margin-bottom: 10px;
            .university-logo{
              height: 50px;
            }
          }

          .qr-codes {
            display: flex;
            gap: 15px;
            justify-content: center;
            margin-top: 15px;

            .qr-code-item {
              .qr-code {
                width: 80px;
                height: 80px;
                background: #fff;
                padding: 0;
                box-sizing: border-box;
                border-radius: 4px;
                display: block;
                object-fit: contain;
              }
            }
          }
        }

        &.contact-section {
          .contact-info {
            display: flex;
            flex-direction: column;
            gap: 15px;

            .contact-item {
              display: flex;
              align-items: flex-start;
              gap: 8px;
              font-size: 14px;
              line-height: 1.6;

              .contact-icon {
                font-size: 16px;
                flex-shrink: 0;
                margin-top: 2px;
                height: 16px;
              }

              .contact-text {
                color: #fff;
                flex: 1;
              }
            }
          }
        }
      }
    }
  }

  .footer-copyright {
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    background: #0065BA;
    position: relative;
    z-index: 3;

    .copyright {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        color: #fff;
      }

      a {
        color: #fff;
        text-decoration: none;
      }
    }
  }
}
</style>
